// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#dropdown {
    margin-left: -5rem;
    border-radius: 5px;
    padding: 0.8rem 15rem 0.8rem 0.5rem;
    color: black;
    background-color: white;
}

#inputField {
    margin-left: 1rem;
    border-radius: 5px;
    padding: 0.8rem 15.5rem 0.8rem 0.5rem;
    border-width: thin;
    color: black !important;
    background: white !important;
    box-shadow: none;
}

#inputField::placeholder {
    color:  black !important;
}

/* input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px #fff inset;
} */

#search {
    margin-left: 1.5rem;
    border-radius: 4px;
    padding: 0.8rem 3rem 0.8rem 3rem;
    border: none;
    background-color: #F36324;
    color: white;
}

#logviews {
    padding-right: 23.5rem;
    font-weight: bold;
    padding-top: 2rem;
}

.user-table {
    padding: 2rem 0rem 2rem 0rem;
}

.headers {
    background-color: rgb(30, 29, 29);
    color: white;
    padding: 2rem 0rem 2rem 0rem !important;
    border-radius: 10px;
}

.table-striped {
    padding: 2rem 0rem 2rem 0rem !important;
}

.table {
    border-top: 10px !important;
}

::ng-deep lib-angular-mydatepicker-calendar {
    position: fixed !important;
    margin-left: -27rem !important;
}

.sort_icon {
    padding-left: 1rem;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/app/logs-view/logs-view.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mCAAmC;IACnC,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;IACrC,kBAAkB;IAClB,uBAAuB;IACvB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAUA;IACI,wBAAwB;AAC5B;;AAEA;;;;;;;;;;GAUG;;AAEH;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,YAAY;IACZ,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iCAAiC;IACjC,YAAY;IACZ,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB","sourcesContent":["#dropdown {\r\n    margin-left: -5rem;\r\n    border-radius: 5px;\r\n    padding: 0.8rem 15rem 0.8rem 0.5rem;\r\n    color: black;\r\n    background-color: white;\r\n}\r\n\r\n#inputField {\r\n    margin-left: 1rem;\r\n    border-radius: 5px;\r\n    padding: 0.8rem 15.5rem 0.8rem 0.5rem;\r\n    border-width: thin;\r\n    color: black !important;\r\n    background: white !important;\r\n    box-shadow: none;\r\n}\r\n\r\n#inputField::-webkit-input-placeholder {\r\n    color: black !important;\r\n}\r\n\r\n#inputField:-ms-input-placeholder {\r\n    color: black !important;\r\n}\r\n\r\n#inputField::placeholder {\r\n    color:  black !important;\r\n}\r\n\r\n/* input:-webkit-autofill,\r\ninput:-webkit-autofill:hover, \r\ninput:-webkit-autofill:focus,\r\ntextarea:-webkit-autofill,\r\ntextarea:-webkit-autofill:hover,\r\ntextarea:-webkit-autofill:focus,\r\nselect:-webkit-autofill,\r\nselect:-webkit-autofill:hover,\r\nselect:-webkit-autofill:focus {\r\n    -webkit-box-shadow: 0 0 0px 1000px #fff inset;\r\n} */\r\n\r\n#search {\r\n    margin-left: 1.5rem;\r\n    border-radius: 4px;\r\n    padding: 0.8rem 3rem 0.8rem 3rem;\r\n    border: none;\r\n    background-color: #F36324;\r\n    color: white;\r\n}\r\n\r\n#logviews {\r\n    padding-right: 23.5rem;\r\n    font-weight: bold;\r\n    padding-top: 2rem;\r\n}\r\n\r\n.user-table {\r\n    padding: 2rem 0rem 2rem 0rem;\r\n}\r\n\r\n.headers {\r\n    background-color: rgb(30, 29, 29);\r\n    color: white;\r\n    padding: 2rem 0rem 2rem 0rem !important;\r\n    border-radius: 10px;\r\n}\r\n\r\n.table-striped {\r\n    padding: 2rem 0rem 2rem 0rem !important;\r\n}\r\n\r\n.table {\r\n    border-top: 10px !important;\r\n}\r\n\r\n::ng-deep lib-angular-mydatepicker-calendar {\r\n    position: fixed !important;\r\n    margin-left: -27rem !important;\r\n}\r\n\r\n.sort_icon {\r\n    padding-left: 1rem;\r\n    cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
